<app-header/>
<div id="myBody">
  <div class="container py-2 mx-auto min-vh-100">
    <div class="row d-flex justify-content-center">

      <div class="container-two rounded">
        <br>
        <div class="d-grid gap-1 d-md-flex header-card-color mb-2 rounded">
          <h6 class="tittle me-auto p-1 rounded"><i class="bi bi-person-fill"></i>&nbsp;<span>PERSONA: MORAL -
              ESTATAL
            </span>
          </h6>
          <div>
            <h6 class="tittle me-auto p-1 rounded">
              <span><i class="bi bi-clipboard2-fill"></i>&nbsp;CERTIFICADO DE NO INFRACCIÓN</span>
            </h6>
          </div>
        </div>

        <mat-vertical-stepper [linear]="!isLinear" #stepper animationDuration="1500" class="container-one rounded">

          <mat-step [stepControl]="PrimerFormGroup">
            <form [formGroup]="PrimerFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-car-front-fill"></i> DATOS
                  DEL VEHÍCULO &nbsp;</h6>
              </ng-template>


              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">NIV <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe NIV" formControlName="niv" id="nivField"
                         appAlphanumeric autocomplete="off" appTrimOnBlur>
                  <small *ngIf="PrimerFormGroup.get('niv')?.invalid && PrimerFormGroup.get('niv')?.touched"
                         class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">PLACA <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe placa" formControlName="placa"
                         id="placaField"
                         appPlaca autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('placa')?.invalid && PrimerFormGroup.get('placa')?.touched"
                         class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">MOTIVO SOLICITUD <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="motivo" autocomplete="off" matTooltip='Seleccionar "Reposición de Placa Y tarjeta de
                          Circulación" en caso de requerir únicamente Reposición de Placa'
                          (change)="onChangeEfectoCertificado($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option *ngFor="let motivo of efectosCertificados"
                            [value]="motivo.id_efecto_certificado">{{ motivo.motivo_de_solicitud }}
                    </option>
                  </select>
                  <small *ngIf="PrimerFormGroup.get('motivo')?.invalid && PrimerFormGroup.get('motivo')?.touched"
                         class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">CERTIFICADO POR: <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="certificadoPor" autocomplete="off"
                          (change)="onChangeCoberturaCertificados($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option *ngFor="let certificado of coberturaCertificados"
                            [value]="certificado.id_cobertura_certificado">
                      {{ certificado.certificado_por }}
                    </option>
                  </select>
                  <small
                    *ngIf="PrimerFormGroup.get('certificadoPor')?.invalid && PrimerFormGroup.get('certificadoPor')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">TIPO SERVICIO <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="tipoServicio" autocomplete="off"
                          (change)="onChangeTipoServicio($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option value="1">PÚBLICO</option>
                    <option value="2">PRIVADO</option>
                  </select>
                  <small
                    *ngIf="PrimerFormGroup.get('tipoServicio')?.invalid && PrimerFormGroup.get('tipoServicio')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">CATEGORIA </label>
                  <input type="text" class="form-control form-color" #categoriaInput formControlName="categoria" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">MARCA </label>
                  <input type="text" class="form-control form-color" #marcaInput formControlName="marca" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">SUBMARCA </label>
                  <input type="text" class="form-control form-color" #submarcaInput formControlName="submarca" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">MODELO </label>
                  <input type="text" class="form-control form-color" #modeloInput formControlName="modelo" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">MOTOR </label>
                  <input type="text" class="form-control form-color" #motorInput formControlName="motor" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">REFRENDO</label>
                  <input type="text" class="form-control form-color" #refrendoInput formControlName="refrendo" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">REPUVE </label>
                  <input type="text" class="form-control form-color" #repuveInput formControlName="repuve" autocomplete="off">
                </div>
              </div>

              <div class="col-12 d-grid gap-1 d-md-flex justify-content-md-end mt-3">
                <button mat-raised-button color="primary" (click)="nextButtonClick()"
                        class="btn text-white buton-next d-flex align-items-center gap-2 rounded"
                        matTooltip="Siguiente paso"
                        matTooltipPosition="above">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>

              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>
            </form>
          </mat-step>

          <mat-step [stepControl]="SegundoGrupo" label="Datos generales">
            <form [formGroup]="SegundoGrupo">
              <ng-template matStepLabel>

                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-building-fill"></i> DATOS
                  DE LA EMPRESA &nbsp;
                </h6>
              </ng-template>

              <div class="row g-3">

                <div class="col-md-3">
                  <label class="form-label">RFC<b class="asteriscos">*</b></label>
                  <div class="input-group">
                    <button type="button" class="btn button-modal" (click)="modalRFCmoral()"><i
                      class="bi bi-info-circle-fill"></i>
                    </button>
                    <input #rfcMoralInput type="text" class="form-control " formControlName="rfcMoral"
                           placeholder="RFC: LLL000000AAA"
                           matTooltip="L = Letra , 0 = Número, A = Letra ó Número, Formato válido: LLL000000AAA"
                           matTooltipPosition="above" autocomplete="off">
                  </div>
                  <small *ngIf="SegundoGrupo.get('rfcMoral')?.invalid && SegundoGrupo.get('categoriaInputrfcMoral')?.touched"
                         class="bg-danger text-white rounded">
                    <b> RFC no válido </b>
                  </small>

                  <small *ngIf="SegundoGrupo.get('rfcMoral')?.valid && SegundoGrupo.get('rfcMoral')?.touched"
                         class="bg-success text-white rounded">
                    <b> RFC válido </b>
                  </small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">FECHA CONSTITUCIÓN <b class="asteriscos">*</b></label>
                  <input #fechaConstitucionInput type="text" class="form-control" formControlName="fechaConstitucion"
                         autocomplete="off">
                </div>

                <div class="col-md-5">
                  <label class="form-label">RAZÓN SOCIAL <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="razonSocial" appName autocomplete="off">
                </div>

              </div>

              <div class="d-grid gap-1 d-md-flex section-tittle mt-4 mb-3 rounded">
                <h6 class="me-auto tittle p-1 rounded">
                  <span>&nbsp;<i class="bi bi-house-add-fill"></i>
                    DOMICILIO FISCAL&nbsp;</span>
                </h6>
              </div>

              <div class="row g-3">

                <div class="col-md-4">
                  <label class="form-label">CALLE <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="calle" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">No. EXTERIOR <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="numExterior"  autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">No. INTERIOR</label>
                  <input type="text" class="form-control" formControlName="numInterior" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">CÓDIGO POSTAL <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="codigoPostal" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">ESTADO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="estado" autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label">MUNICIPIO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="municipio" autocomplete="off">

                </div>

                <div class="col-md-4">
                  <label class="form-label">LOCALIDAD <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="localidad" autocomplete="off">
                </div>
              </div>

              <br>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <button mat-raised-button color="primary" (click)="nextButtonClick2()" matTooltip="Siguiente paso"
                        matTooltipPosition="above"
                        class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son
                obligatorios</p>
            </form>
          </mat-step>

          <mat-step [stepControl]="TercerFormGroup" label="Medios de Contacto">
            <form [formGroup]="TercerFormGroup">

              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-telephone-plus-fill"></i>
                  MEDIOS DE
                  CONTACTO &nbsp;</h6>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">NÚMERO TELÉFONO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe tu Número de Teléfono"
                         formControlName="numeroTelefono" [minlength]="10" [maxlength]="10" appNumeric
                         matTooltip="tu número de teléfono debe contener 10 números" matTooltipPosition="above"
                         autocomplete="off">
                  <small
                    *ngIf="TercerFormGroup.get('numeroTelefono')?.invalid && TercerFormGroup.get('numeroTelefono')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">CORREO ELECTRÓNICO <b class="asteriscos">*</b></label>
                  <input type="email" class="form-control" placeholder="Escribe tu Correo Electrónico"
                         name="correoElectronico" formControlName="correoElectronico"
                         matTooltip="Formato correo: nombre@ejemplo.com" matTooltipPosition="above" autocomplete="off">
                  <small
                    *ngIf="TercerFormGroup.get('correoElectronico')?.invalid && TercerFormGroup.get('correoElectronico')?.touched"
                    class="bg-danger text-white rounded">
                    <b> Correo Electrónico no válido </b>
                  </small>

                  <small
                    *ngIf="TercerFormGroup.get('correoElectronico')?.valid && TercerFormGroup.get('correoElectronico')?.touched"
                    class="bg-success text-white rounded">
                    <b> Correo Electrónico válido </b>
                  </small>
                </div>

              </div>
              <br>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <button mat-raised-button color="primary" (click)="nextButtonClick3()" matTooltip="Siguiente paso"
                        matTooltipPosition="above"
                        class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>


              <hr>

              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>

            </form>
          </mat-step>

          <mat-step [stepControl]="CuartoFormGroup" label="Datos (Representante Legal)">
            <form [formGroup]="CuartoFormGroup">
              <ng-template matStepLabel>

                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-person-fill-add"></i>
                  DATOS (REPRESENTANTE LEGAL) &nbsp;
                </h6>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">RFC <b class="asteriscos">*</b></label>
                  <div class="input-group">
                    <button type="button" class="btn button-modal" (click)="modalRFC()">
                      <i class="bi bi-info-circle-fill"></i>
                    </button>
                    <input type="text" class="form-control"
                           placeholder="R.F.C. LLLL000000AAA"
                           formControlName="rfc"
                           (input)="pasarValorRfcACurp()"
                           maxlength="13"
                           appAlphanumeric
                           autocomplete="off"
                           [ngClass]="{
             'is-valid': CuartoFormGroup.get('rfc')?.valid && CuartoFormGroup.get('rfc')?.touched,
             'is-invalid': CuartoFormGroup.get('rfc')?.invalid && CuartoFormGroup.get('rfc')?.touched
           }">
                  </div>
                  <small *ngIf="CuartoFormGroup.get('rfc')?.invalid && CuartoFormGroup.get('rfc')?.touched"
                         class="bg-danger text-white rounded">
                    <b> RFC no válido </b>
                  </small>

                  <small *ngIf="CuartoFormGroup.get('rfc')?.valid && CuartoFormGroup.get('rfc')?.touched"
                         class="bg-success text-white rounded">
                    <b> RFC válido </b>
                  </small>
                  <div *ngIf="CuartoFormGroup.get('rfc')?.invalid && CuartoFormGroup.get('rfc')?.touched"
                       class="invalid-feedback">
                    El RFC debe tener 13 caracteres en un formato válido.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">CURP <b class="asteriscos">*</b></label>
                  <div class="input-group">
                    <button type="button" class="btn button-modal" (click)="modalCURP()">
                      <i class="bi bi-info-circle-fill"></i>
                    </button>
                    <input type="text" class="form-control" placeholder="CURP: LLLL000000LLLLLLA0"
                           formControlName="curp" [minlength]="18" [maxlength]="18" appAlphanumeric autocomplete="off">
                  </div>
                  <small *ngIf="CuartoFormGroup.get('curp')?.invalid && CuartoFormGroup.get('curp')?.touched"
                         class="bg-danger text-white rounded">
                    <b> CURP no válido </b>
                  </small>

                  <small *ngIf="CuartoFormGroup.get('curp')?.valid && CuartoFormGroup.get('curp')?.touched"
                         class="bg-success text-white rounded">
                    <b> CURP válido </b>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="nombre">NOMBRE <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="nombre" id="nombre"
                         placeholder="Escribe el nombre del propietario" appLetters autocomplete="off">
                  <small *ngIf="CuartoFormGroup.get('nombre')?.touched && CuartoFormGroup.get('nombre')?.errors"
                         class="text-danger">
                    <p *ngIf="CuartoFormGroup.get('nombre')?.errors?.['required']">Campo obligatorio.</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="apellidoPaterno">APELLIDO PATERNO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="apellidoPaterno" id="apellidoPaterno"
                         placeholder="Escribe el apellido paterno" appLetters autocomplete="off">
                  <small *ngIf="CuartoFormGroup.get('apellidoPaterno')?.touched && CuartoFormGroup.get('apellidoPaterno')?.errors"
                         class="text-danger">
                    <p *ngIf="CuartoFormGroup.get('apellidoPaterno')?.errors?.['required']">Campo obligatorio.</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="apellidoMaterno">APELLIDO MATERNO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="apellidoMaterno" id="apellidoMaterno"
                         placeholder="Escribe el apellido materno" appLetters autocomplete="off">
                  <small *ngIf="CuartoFormGroup.get('apellidoMaterno')?.touched && CuartoFormGroup.get('apellidoMaterno')?.errors"
                         class="text-danger">
                    <p *ngIf="CuartoFormGroup.get('apellidoMaterno')?.errors?.['required']">Campo obligatorio.</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label">SEXO <b class="asteriscos">*</b></label>
                  <input #sexoInput type="text" class="form-control" formControlName="sexo" autocomplete="off">

                </div>

                <div class="col-md-4">
                  <label class="form-label">FECHA NACIMIENTO <b class="asteriscos">*</b></label>
                  <input #fechaNacimientoInput type="text" class="form-control" formControlName="fechaNacimiento"
                         autocomplete="off">
                </div>

              </div>

              <br>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <button mat-raised-button color="primary" (click)="nextButtonClick4()" matTooltip="Siguiente paso"
                        matTooltipPosition="above"
                        class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son
                obligatorios</p>
            </form>
          </mat-step>

          <mat-step [stepControl]="QuintoFormGroup" label="Descargar documento">
            <form [formGroup]="QuintoFormGroup">

              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-file-arrow-down-fill"></i>
                  DESCARGAR DOCUMENTO &nbsp;</h6>

              </ng-template>

              <div class="container alert alert-light shadow-lg rounded p-4">
                <p class="fw-bold text-uppercase mb-3">
                  Instrucciones de la SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN
                </p>
                <p class="text-justify mb-2">
                  Para completar este trámite, siga los siguientes pasos cuidadosamente:
                </p>
                <ol class="mb-3">
                  <li><b>Descargue</b> el formato de <b>SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b>, haciendo clic en
                    el botón <b>“Descargar formato de solicitud”</b> que se muestra abajo.
                  </li>
                  <li><b>Firme</b> el formato de solicitud descargado.</li>
                  <li><b>Escanee</b> el formato de solicitud ya firmado y <b>guárdelo</b> en formato <b>PDF</b> en su
                    dispositivo.
                  </li>
                  <li>Una vez que tenga el archivo listo, de clic en el botón <b>Siguiente</b> para continuar a la
                    sección de
                    <b>DOCUMENTOS</b>.
                  </li>
                </ol>
                <div class="text-center">
                  <button type="button" mat-flat-button color="primary" class="mb2" (click)="descargarDocumento()">
                    <i class="bi bi-cloud-arrow-down-fill me-2"></i> Descargar formato de solicitud
                  </button>
                </div>
                <br>
                <div class="col-12 shadow p-3 rounded margin bg-white">
                  <div class="ml-2 form-check">
                    <input class="form-check-input" type="checkbox" formControlName="documentos" id="documentos">
                    <label class="form-check-label" for="documentos">
                      Tengo listo el <b>Formato de solicitud </b> y deseo continuar a la siguiente sección. <b
                      class="asteriscos">*</b>
                    </label>
                    <div class="invalid-feedback">
                      debes aceptar para continuar
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <button mat-raised-button color="primary" (click)="nextButtonClick5()" matTooltip="Siguiente paso"
                        matTooltipPosition="above"
                        class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>

              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>

            </form>
          </mat-step>

          <mat-step [stepControl]="SextoFormGroup" label="Documentos">
            <form [formGroup]="SextoFormGroup">

              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-file-pdf-fill"></i>
                  DOCUMENTOS &nbsp;</h6>

              </ng-template>

              <div class="container alert alert-light shadow-sm rounded p-4 mt-3">
                <h5 class="text-center text-primary mb-3"><b>Instrucciones para la carga de documentos solicitados</b>
                </h5>
                <ol class="mb-3">
                  <li>Revise cuidadosamente los documentos que la plataforma le solicita.</li>
                  <li>Asegúrese de tener cada documento en formato <b>PDF</b>.</li>
                  <li>Para cada documento solicitado:
                    <ul class="mt-2">
                      <li>Presione el botón con el ícono
                        <i class="bi bi-cloud-arrow-up-fill text-primary mx-1" style="font-size: 18px;"></i>
                        para <b>adjuntar el archivo</b> desde su dispositivo.
                      </li>
                      <li>Use el botón con el ícono
                        <i class="bi bi-eye-fill text-success mx-1" style="font-size: 18px;"></i>
                        para <b>visualizar el archivo</b> antes de enviarlo.
                      </li>
                    </ul>
                  </li>
                </ol>
                <p><strong>Nota: </strong>En el documento <strong>Factura</strong>. </p>

                <ul>
                  <li>Si su vehículo fue refacturado, debe anexar el seguimiento o el historial de facturas.</li>
                  <li>Si su vehículo tiene factura digital, debe anexar su comprobante fiscal.</li>
                  <li>
                    Para unidades del año <b>2014</b> en adelante, anexar contrato de
                    compraventa junto con la identificación oficial <b>(INE)</b> del vendedor y del
                    comprador.
                  </li>
                  <li>
                    Para modelos del año <b>2013</b> o anteriores, ya no es necesario presentar el contrato
                    de compraventa.
                  </li>
                </ul>
              </div>

              <div class="row justify-content-center">

                <div *ngFor="let doc of documentos"
                     class="card cards me-2 mt-2"
                     style="width: 18rem;"
                     matTooltipPosition="above">

                  <div class="card-body">
                    <ng-container *ngIf="doc.urlVisor; else noPdf">
                      <iframe [src]="doc.urlVisor" width="100%" height="300"
                              class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="card-iframe  pdf-placeholder mb-2" style="height: 300px;">
                      </div>
                    </ng-template>

                    <div *ngIf="isUploading[doc.id]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar"
                           [style.width.%]="uploadProgress[doc.id]"
                           [attr.aria-valuenow]="uploadProgress[doc.id]">
                        {{ uploadProgress[doc.id] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">
                        <input type="file" #fileInput accept=".pdf"
                               (change)="onFileSelected(fileInput, doc)"
                               style="display: none"/>

                        <button type="button" class="btn button-upload" (click)="fileInput.click()"
                                [matTooltip]="doc.titulo === 'INE REPRESENTANTE LEGAL' ? 'Seleccionar Documento, INE debe ser digitalizado por ambos lados' : 'Seleccionar Documento'">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom"
                                (click)="verDocumentoEnVentana(doc)"
                                matTooltip="Ver Documento"
                                [disabled]="!doc.urlVisor">
                          <i class="bi bi-eye-fill"></i>
                        </button>
                      </div>
                      <hr/>
                      <h6 class="card-title tittle text-center rounded">{{ doc.titulo }}</h6>
                    </div>
                  </div>
                </div>

              </div>
              <br>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <button mat-raised-button color="primary" (click)="nextButtonClick6()" matTooltip="Siguiente paso"
                        matTooltipPosition="above"
                        class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>

              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>

            </form>
          </mat-step>

          <mat-step [stepControl]="SeptimoFormGroup" label="Termino de Revision">
            <form [formGroup]="SeptimoFormGroup">

              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-pencil-square"></i> AVISO DE CONFORMIDAD
                  &nbsp;</h6>
              </ng-template>

              <br>

              <div class="row g-3 alert alert-light shadow-lg p-3 mb-5 rounded">
                <br>
                <figure>
                  <blockquote class="blockquote">
                    <p>Acepto que los servicios que a través de este medio se
                      pagan,
                      se sujeten a los requisitos que las disposiciones fiscales y administrativas
                      señalen
                      para tales efectos
                      y que en caso de no cumplir con aquéllos, quede expedito mi derecho para
                      solicitar
                      la devolución de este pago,
                      conforme a derecho corresponda.</p>
                    <hr>

                  </blockquote>
                </figure>

                <div class="col-12 shadow p-3 rounded margin bg-white">
                  <div class="ml-2 form-check">
                    <input class="form-check-input" type="checkbox" formControlName="terminosCondiciones"
                           id="terminosCondiciones">
                    <label class="form-check-label" for="terminosCondiciones">
                      He
                      leído y acepto los
                      <a href="#" role="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Términos y condiciones
                      </a> <b class="asteriscos">*</b>
                    </label>
                    <div class="invalid-feedback">
                      Primero debes aceptar los términos y condiciones.
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal fade text-center" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false"
                   tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header header-modal">
                      <h5 class="modal-title" id="staticBackdropLabel">AVISO DE PRIVACIDAD</h5>
                      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                              aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <h5 class="fw-bold text-start">
                        Aviso de Privacidad Simplificado
                      </h5>

                      <p class="text-start">
                        Con fundamento en los artículos 17 y 18 de la Ley de Protección de Datos Personales en Posesión
                        de Sujetos Obligados del Estado de Tlaxcala, la Secretaría de Movilidad y Transporte del Estado
                        de Tlaxcala emite el presente Aviso de Privacidad Simplificado, dirigido a la ciudadanía que
                        acude a realizar trámites ante esta dependencia.
                      </p>

                      <p class="text-start">
                        Esta Secretaría podrá recabar los siguientes datos personales: nombre completo, domicilio, edad,
                        género, nivel de escolaridad, RFC, CURP, huellas dactilares, tipo de sangre, correo electrónico,
                        número telefónico y firma. Asimismo, se podrán recabar datos vehiculares, como el número de
                        identificación vehicular (NIV) y la placa de circulación, así como datos sensibles, tales como
                        dictámenes médicos.
                      </p>

                      <p class="text-start">
                        Los datos personales serán utilizados con las finalidades de gestionar trámites y servicios
                        relacionados con el transporte público y privado, así como la expedición de licencias para
                        conducir en sus modalidades presencial y virtual a través de la plataforma en línea. De manera
                        adicional, podrán emplearse con fines estadísticos, de control administrativo e informes sobre
                        el servicio proporcionado.
                      </p>

                      <p class="text-start">
                        Se informa que los datos proporcionados podrán ser transferidos a la Secretaría de Finanzas del
                        Estado de Tlaxcala con fines recaudatorios, conforme a lo dispuesto en el artículo 1 de la Ley
                        de Ingresos para el Estado de Tlaxcala.
                      </p>

                      <p class="text-start">
                        El titular de los datos personales podrá ejercer sus derechos en relación con el tratamiento de
                        los mismos mediante un escrito libre dirigido a la Unidad de Transparencia o al Oficial de
                        Protección de Datos Personales de esta Secretaría, al correo electrónico:
                        <strong>transparencia&#64;smytlax.gob.mx</strong>, o bien, comunicándose al teléfono <strong>246
                        465 2960</strong> ext. <strong>3304</strong>, en un horario de atención de lunes a viernes de
                        08:00 a 17:00 horas.
                      </p>

                      <p class="text-start">
                        Usted está consultando el Aviso de Privacidad Simplificado correspondiente a los trámites
                        realizados de manera presencial o virtual ante esta Secretaría. Para consultar el Aviso de
                        Privacidad Integral, puede acceder al siguiente sitio web:
                        <br>
                        <a href="https://smyt.tlaxcala.gob.mx/" target="_blank"
                           class="fw-bold text-decoration-underline">https://smyt.tlaxcala.gob.mx/</a>
                      </p>
                    </div>

                    <div class="modal-footer">
                      <button type="button" class="btn button-close" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex bd-highlight mb-3">
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                        matTooltipPosition="above"
                        class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <div>
                  <button mat-raised-button color="primary" (click)="nextButtonClick7()"
                          matTooltip="Guardar toda la información" matTooltipPosition="above"
                          class="btn button-save text-white d-flex align-items-center gap-2 rounded">
                    <mat-icon>save</mat-icon>
                    Guardar
                  </button>
                </div>
              </div>

              <hr>
            </form>

          </mat-step>
        </mat-vertical-stepper>
        <br>
      </div>
    </div>
  </div>
  <app-footer/>
  <div class="blur-container" *ngIf="mostrarSpinner">
    <div class="spinner-container">
      <img src="/assets/Spinner/Logotipo.png" class="rotating-image mb-2" alt="Spinner">
      <p class="loading-text"><b>Procesando, por favor espere...</b></p>
    </div>
  </div>
</div>